/* DUNKPOINT product page: gallery, variant pills, YMQ bridge, customise tabs,
   store credit line, sticky bar, size guide and review placement.
   Reads config from data attributes. */
(function () {
  function init(root) {
    if (!root || root.dataset.dpReady) return;
    root.dataset.dpReady = '1';

    var variants = JSON.parse(root.querySelector('[data-dp-variants]').textContent);
    var strings = JSON.parse(root.querySelector('[data-dp-strings]').textContent);
    var input = root.querySelector('[data-dp-variant-input]');
    var optionWraps = Array.prototype.slice.call(root.querySelectorAll('[data-dp-option]'));
    var atc = root.querySelector('[data-dp-atc]');
    var atcText = root.querySelector('[data-dp-atc-text]');
    var sticky = root.querySelector('[data-dp-sticky]');
    var stickyAtc = root.querySelector('[data-dp-sticky-atc]');
    var stickySelect = root.querySelector('[data-dp-sticky-select]');
    var slider = root.querySelector('[data-dp-slider]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dp-thumb]'));
    var counter = root.querySelector('[data-dp-count]');
    var earnWrap = root.querySelector('[data-dp-earn-percent]');
    var sizeIndex = Number(root.dataset.sizeIndex);

    var current = variants.filter(function (v) { return String(v.id) === input.value; })[0] || variants[0];
    var selected = current ? current.options.slice() : [];

    function findVariant(values) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      })[0];
    }

    function formatMoney(amount) {
      var cents = Math.round(parseFloat(amount) * 100);
      var value = (cents / 100).toFixed(2);
      var fmt = strings.moneyFormat || '{{amount}}';
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        if (key.indexOf('comma') > -1) return value.replace('.', ',');
        if (key.indexOf('no_decimals') > -1) return String(Math.round(cents / 100));
        return value;
      }).replace(/<[^>]*>/g, '');
    }

    /* ---------- gallery ---------- */
    function slides() { return slider ? Array.prototype.slice.call(slider.children) : []; }
    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = index + 1;
      /* Mobile: the thumbnail column scrolls on its own, keep the active one in view. */
      var t = thumbs[index];
      var col = t && t.parentNode;
      if (col && window.matchMedia('(max-width: 1023px)').matches && col.scrollHeight > col.clientHeight) {
        if (t.offsetTop < col.scrollTop) col.scrollTop = t.offsetTop - 4;
        else if (t.offsetTop + t.offsetHeight > col.scrollTop + col.clientHeight) col.scrollTop = t.offsetTop + t.offsetHeight - col.clientHeight + 4;
      }
    }
    function goToIndex(index, smooth) {
      var list = slides();
      if (!list[index]) return;
      slider.scrollTo({ left: list[index].offsetLeft - slider.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(index);
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goToIndex(Number(thumb.dataset.dpThumb), true); });
    });
    if (slider) {
      var scrollTimer;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          setActive(Math.round(slider.scrollLeft / slider.clientWidth));
        }, 60);
      }, { passive: true });
    }

    /* ---------- variant state ---------- */
    function render(fromUser) {
      var variant = findVariant(selected);

      optionWraps.forEach(function (wrap) {
        var i = Number(wrap.dataset.dpOption);
        var label = wrap.querySelector('[data-dp-selected]');
        if (label) label.textContent = selected[i];
        wrap.querySelectorAll('.dp-pill').forEach(function (pill) {
          var isOn = pill.dataset.value === selected[i];
          var test = selected.slice();
          test[i] = pill.dataset.value;
          var match = findVariant(test);
          pill.classList.toggle('is-selected', isOn);
          pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
          pill.classList.toggle('is-unavailable', !match || !match.available);
        });
        var select = wrap.querySelector('[data-dp-select]');
        if (select) select.value = selected[i];
      });
      if (stickySelect && sizeIndex >= 0) stickySelect.value = selected[sizeIndex];

      if (!variant) {
        atc.disabled = true;
        atcText.textContent = strings.unavailable;
        if (stickyAtc) { stickyAtc.disabled = true; stickyAtc.textContent = strings.unavailable; }
        return;
      }

      input.value = variant.id;
      root.querySelectorAll('[data-dp-now]').forEach(function (el) { el.textContent = variant.price; });
      root.querySelectorAll('[data-dp-compare]').forEach(function (el) {
        el.hidden = !variant.compare;
        if (variant.compare) el.textContent = variant.compare;
      });
      root.querySelectorAll('[data-dp-off]').forEach(function (el) {
        el.hidden = !variant.off;
        el.textContent = '-' + variant.off + '%';
      });

      /* Store credit earned on this variant, rounded down to the cent like the Liquid value. */
      if (earnWrap && typeof variant.cents === 'number') {
        var earnCents = Math.floor(variant.cents * Number(earnWrap.dataset.dpEarnPercent) / 100);
        var earnEl = earnWrap.querySelector('[data-dp-earn]');
        if (earnEl) earnEl.textContent = formatMoney(earnCents / 100);
      }

      var label = variant.available ? strings.add : strings.soldOut;
      atc.disabled = !variant.available;
      atcText.textContent = label;
      if (stickyAtc) { stickyAtc.disabled = !variant.available; stickyAtc.textContent = label; }

      if (fromUser) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        if (variant.media) {
          var index = slides().findIndex(function (s) { return s.dataset.mediaId === String(variant.media); });
          if (index > -1) goToIndex(index, true);
        }
      }
    }

    /* YMQ Product Options owns the variant dropdowns (ymq-option1..N) and the
       Name + Number personalisation. Its UI stays in the form (off-screen) and
       our controls drive it, so the cart still gets YMQ's properties and fee. */
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var syncingFromApp = false;

    function appSelect(i) {
      return form ? form.querySelector('select[name="ymq-option' + (i + 1) + '"]') : null;
    }
    function pushToApp(i) {
      var s = appSelect(i);
      if (!s || s.value === selected[i]) return;
      var exists = Array.prototype.some.call(s.options, function (o) { return o.value === selected[i]; });
      if (!exists) return;
      s.value = selected[i];
      s.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function choose(i, value) {
      selected[i] = value;
      render(true);
      if (!syncingFromApp) pushToApp(i);
    }
    if (form) {
      form.addEventListener('change', function (event) {
        var match = event.target.name && event.target.name.match(/^ymq-option(\d+)$/);
        if (!match || syncingFromApp) return;
        var i = Number(match[1]) - 1;
        if (selected[i] === event.target.value) return;
        syncingFromApp = true;
        choose(i, event.target.value);
        syncingFromApp = false;
      });
    }

    optionWraps.forEach(function (wrap) {
      var i = Number(wrap.dataset.dpOption);
      wrap.querySelectorAll('.dp-pill').forEach(function (pill) {
        pill.addEventListener('click', function () { choose(i, pill.dataset.value); });
      });
      var select = wrap.querySelector('[data-dp-select]');
      if (select) select.addEventListener('change', function () { choose(i, select.value); });
    });

    /* ---------- customise: choose player / add your name ---------- */
    var custom = root.querySelector('[data-dp-custom]');
    var tabsWrap = root.querySelector('[data-dp-custom-tabs]');
    var tabPlayer = root.querySelector('[data-dp-custom-tab="player"]');
    var tabName = root.querySelector('[data-dp-custom-tab="name"]');
    var panelPlayer = root.querySelector('[data-dp-custom-panel="player"]');
    var panelName = root.querySelector('[data-dp-custom-panel="name"]');
    var priceTag = root.querySelector('[data-dp-custom-price]');
    var nameInput = root.querySelector('[data-dp-custom-name]');
    var numberInput = root.querySelector('[data-dp-custom-number]');
    var mode = panelPlayer ? 'player' : 'name';
    var nameEnabled = false;

    function ymqToggle() { return form && form.querySelector('.ymq-options-box-13 input[type="checkbox"]'); }
    function ymqField(label) {
      return form && form.querySelector('textarea[name="ymq[' + label + ']"], input[name="ymq[' + label + ']"]');
    }
    function writeField(el, value) {
      if (!el) return;
      el.value = value;
      ['input', 'change', 'keyup', 'blur'].forEach(function (type) {
        el.dispatchEvent(new Event(type, { bubbles: true }));
      });
    }
    function pushName() {
      writeField(ymqField('Name'), (nameInput.value || '').toUpperCase());
      writeField(ymqField('Number'), numberInput.value || '');
    }
    function setMode(next) {
      mode = next;
      if (tabPlayer) tabPlayer.classList.toggle('is-active', next === 'player');
      if (tabName) tabName.classList.toggle('is-active', next === 'name');
      if (panelPlayer) panelPlayer.hidden = next !== 'player';
      if (panelName) panelName.hidden = next !== 'name';
      var toggle = ymqToggle();
      if (priceTag) priceTag.hidden = !(next === 'name' && toggle && parseFloat(toggle.dataset.price) > 0);
      if (toggle) {
        var want = next === 'name';
        if (toggle.checked !== want) toggle.click();
        if (want) setTimeout(pushName, 40);
      }
    }
    if (tabPlayer) tabPlayer.addEventListener('click', function () { setMode('player'); });
    if (tabName) tabName.addEventListener('click', function () { setMode('name'); });
    if (nameInput) nameInput.addEventListener('input', function () { writeField(ymqField('Name'), nameInput.value.toUpperCase()); });
    if (numberInput) numberInput.addEventListener('input', function () {
      numberInput.value = numberInput.value.replace(/[^0-9]/g, '').slice(0, 2);
      writeField(ymqField('Number'), numberInput.value);
    });

    function syncAppUi() {
      if (!form) return;
      var box = form.querySelector(':scope > #ymq-box');
      var anchors = form.querySelectorAll(':scope > .dp-opt, :scope > .dp-custom');
      var last = anchors[anchors.length - 1];
      if (box && last && last.nextElementSibling !== box) last.after(box);

      var toggle = ymqToggle();
      if (toggle && !nameEnabled) {
        nameEnabled = true;
        tabName.hidden = false;
        custom.hidden = false;
        if (priceTag && parseFloat(toggle.dataset.price) > 0) priceTag.textContent = '+ ' + formatMoney(toggle.dataset.price);
        if (panelPlayer) {
          tabsWrap.hidden = false;
          setMode(toggle.checked ? 'name' : 'player');
        } else {
          tabsWrap.hidden = true;
          setMode('name');
        }
      }
    }
    if (form) {
      syncAppUi();
      new MutationObserver(syncAppUi).observe(form, { childList: true, subtree: true });
      form.addEventListener('submit', function (e) {
        if (mode === 'name' && ymqToggle() && !(nameInput.value || '').trim()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          nameInput.focus();
          nameInput.classList.add('is-invalid');
          setTimeout(function () { nameInput.classList.remove('is-invalid'); }, 1600);
        } else if (mode === 'name') {
          pushName();
        }
      }, true);
    }

    /* ---------- sticky bar ---------- */
    if (stickySelect) stickySelect.addEventListener('change', function () { choose(sizeIndex, stickySelect.value); });
    if (stickyAtc) stickyAtc.addEventListener('click', function () { atc.click(); });
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('select, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
        document.body.classList.toggle('dp-has-sticky', show);
      }).observe(atc);
    }

    /* ---------- size guide ---------- */
    var guide = root.querySelector('[data-dp-guide]');
    if (guide) {
      document.body.appendChild(guide);
      var openGuide = function (open) {
        guide.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      root.querySelectorAll('[data-dp-guide-open]').forEach(function (b) { b.addEventListener('click', function () { openGuide(true); }); });
      guide.querySelectorAll('[data-dp-guide-close]').forEach(function (b) { b.addEventListener('click', function () { openGuide(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !guide.hidden) openGuide(false); });
    }

    /* ---------- reviews under the gallery: mobile "show all" button ---------- */
    var tppMore = root.querySelector('[data-dp-tpp-more]');
    if (tppMore) {
      tppMore.addEventListener('click', function () {
        var box = tppMore.closest('.dp-tpp');
        if (box) box.classList.add('is-open');
        tppMore.setAttribute('aria-expanded', 'true');
      });
    }

    /* ---------- reviews: under the gallery on desktop, after details on mobile ---------- */
    var reviews = document.querySelector('.dp-reviews--list');
    var reviewsHost = reviews && reviews.closest('.shopify-section');
    if (reviewsHost && !(window.Shopify && Shopify.designMode)) {
      var slot = document.createElement('div');
      slot.className = 'dp-pdp__reviews-slot';
      slot.appendChild(reviews);
      var media = root.querySelector('.dp-pdp__media');
      var info = root.querySelector('.dp-pdp__info');
      var mq = window.matchMedia('(min-width: 1024px)');
      var place = function () {
        if (mq.matches) media.appendChild(slot); else info.appendChild(slot);
      };
      place();
      if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
      root.classList.add('has-reviews-slot');
      reviewsHost.hidden = true;
    }

    var initialIndex = slides().findIndex(function (s) { return s.dataset.mediaId === root.dataset.featuredMedia; });
    if (initialIndex > 0) goToIndex(initialIndex, false);
    render(false);
  }

  function boot() { document.querySelectorAll('[data-dp-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
